import React from 'react';
import { QrCodeContainer, QrCodeContent, QrcodeSubtitle } from './qr-code-login.styles';

export function QrCodeLogin({
  consumerPhoneLoginUrl,
  className,
  size = 220,
}: {
  consumerPhoneLoginUrl: string;
  className?: string;
  size?: number;
}): JSX.Element {
  return (
    <QrCodeContainer className={className}>
      <QrCodeContent data-testid='qr-code' value={consumerPhoneLoginUrl} size={size} marginSize={2} />
      <QrcodeSubtitle>
        Scan to login
        <br />
        on your phone
      </QrcodeSubtitle>
    </QrCodeContainer>
  );
}
